<div class="block">
  <div class="left">    
    <app-site-content key="MultiClaimCalculator.Info"></app-site-content>
  </div>
  <div class="right">
    <div class="headers">
      <h4>Policy sum assured</h4>
      <h4 class="amount">
        <span class="input">
          <input [(ngModel)]="enteredValue" (ngModelChange)="valueChanged(enteredValue)" currencyMask
            [options]="{ prefix: '£'}" [ngModelOptions]="{updateOn:'blur'}" />
        </span>
      </h4>
    </div>
    <div class="slider">
      <ngx-slider [(value)]="value" (mouseup)="valueChanged(value)" [options]="options"></ngx-slider>
    </div>
    <div class="instructions">
      Use slide to select policy sum assured or enter a value
    </div>
  </div>
</div>
